module.exports = __webpack_public_path__ + "img/Logo-13.68abefe7.svg";